import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import styles from './ScrollButton.module.scss';
export const ScrollButton = ({ onClick, className, style, children }) => {
    return (_jsx("div", Object.assign({ className: styles['scroll-btn-container'] }, { children: _jsx("button", Object.assign({ style: style, className: clsx(styles['scroll-btn'], className), "data-test": "scroll-button", onClick: onClick }, { children: children }), void 0) }), void 0));
};
//# sourceMappingURL=ScrollButton.js.map